import { useCallback, useEffect, useState } from "react";

import { getMenuItem } from "services/menu/rest";
import { MenuItemDto } from "services/menu/restModels";

export interface UseMenuItemResult {
    item: MenuItemDto | null;
    loading: boolean;
    error: boolean;
    refetch: () => void;
}

export const useMenuItem = (menuItemId: number): UseMenuItemResult => {
    const [item, setItem] = useState<MenuItemDto | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);

    const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

    useEffect(() => {
        // ignore-флаг: поздний ответ по старому menuItemId не перезапишет свежий.
        let ignore = false;

        setLoading(true);
        setError(false);

        getMenuItem(menuItemId)
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setItem(result);
                } else {
                    setError(true);
                    setItem(null);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setItem(null);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [menuItemId, reloadKey]);

    return { item, loading, error, refetch };
};
